
import api from 'api';
import { processPromise } from '@helpers/functions';

const login = {};

login.doLogin = (access, password) => {
  return new Promise((resolve, reject) => {
    api.post('/login', {access , password}).then((result) => {
      const response = processPromise(true, result);
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
});

}


export default login
